import { render, staticRenderFns } from "./gak-global.en.vue?vue&type=template&id=073c4e7e&"
import script from "./gak-global.en.vue?vue&type=script&lang=js&"
export * from "./gak-global.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports